import { Component, Input } from '@angular/core';

import { IContractLot } from 'src/app/models/generic';

@Component({
  selector: 'app-card-manual-batch-contract',
  templateUrl: './card-manual-batch-contract.component.html',
  styleUrls: ['./card-manual-batch-contract.component.scss']
})
export class CardManualBatchContractComponent {
  @Input() contract!: IContractLot;
  @Input() linha!: number | undefined;

  bodyExpanded: boolean = false;

  constructor() { }

  get isStoreConfig(): boolean {
    const channel = this.contract?.Chanel?.toLowerCase();
    const hasSubestabelecidoContract = !!this.contract?.SubestabelecidoContract;
    return channel === 'loja' || hasSubestabelecidoContract;
  }

  get isReverseContract(): boolean {
    const status = this.contract?.Status?.toLowerCase() || '';
    return this.contract?.ToReverse === true
      || status === 'a estornar'
      || status === 'estornar'
      || status === 'estornado parcial'
      || status === 'estornado';
  }
}
